const items = {
  "auth.role.label": "role",
  "auth.role.all": "all",
  "auth.role.owner": "owner",
  "auth.role.manager": "manager",
  "auth.role.editor": "editor",
  "auth.role.member": "member",
  "auth.role.student": "student",
  "auth.role.assistant": "assistant",
  "auth.role.unknown": "unknown",
  "auth.role.delete": "delete",
  "auth.role.reader": "reader",
  "auth.type.user": "user",
  "auth.type.group": "group",
  "auth.sign-up.email-certification": "E-Mail certification",
  "auth.sign-up.info": "完善个人信息",
};

export default items;
